import moment from 'moment';
import { compose, withProps } from 'recompose';

import withTimezone from '../../../../auth/utils/withTimezone';

export default (propName = 'endingDateMax') => compose(
  withTimezone,
  withProps(
    (props) => {
      if (props[propName] !== undefined) {
        return {};
      }
      return { [propName]: moment().tz(props.timezone).startOf('day').toDate() };
    }
  )
);
